<template>
    <section class="featured light-bg pt-55 pb-40">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="section__head d-flex justify-content-between mb-30">
              <div class="section__title">
                <h5 class="st-titile">Top Featured Products</h5>
              </div>
              <div class="button-wrap">
                <router-link to="/shop">See All Products <i class="fas fa-chevron-right"></i></router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <product-feature-single-big :product="featured_first"></product-feature-single-big>
          </div>
          <div class="col-xl-6 col-lg-12">
            <div class="row">
              <div v-for="product in featured_sm_prd.slice(0, 2)" :key="product.id" class="col-md-6">
                <product-single-feature :product="product"></product-single-feature>
              </div>
            </div>
            <div class="row">
              <div v-for="product in featured_sm_prd.slice(2, 4)" :key="product.id" class="col-md-6">
                <product-single-feature :product="product"></product-single-feature>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
<script>
import ProductFeatureSingleBig from '@/components/product/product-feature-single-big.vue'
import ProductSingleFeature from '@/components/product/product-single-feature.vue'
import { useProductFilterStore } from "@/stores/useProductFilterStore"

export default {
  name: "HeaderOne",
  components: {
    ProductFeatureSingleBig,
    ProductSingleFeature
  },
  data() {
    const store = useProductFilterStore()
    return {
      store,
      cate_menu: false,
      isSidebarOpen: false,
      featured_prd: [],
      featured_first: {},
      featured_sm_prd: []
    }
  },
  methods: {
    async fetchProducts() {
      try {
        const response = await this.$axios.get(`/top-featured-products`)
        this.featured_prd = response.data
        this.featured_first = this.featured_prd[0]
        this.featured_sm_prd = this.featured_prd.slice(1)
      } catch (error) {
        console.error("Error fetching products:", error)
      }
    }
  },
  mounted() {
    this.fetchProducts()
  }
}
</script>
